import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "revoked",
  "use": "revoked-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"revoked\"><title>Shape</title><g data-name=\"图层 2\"><path d=\"M3.51 20.49a12 12 0 1 1 17 0 12 12 0 0 1-17 0zM8 2.5a10.31 10.31 0 1 0 11.3 2.21A10.31 10.31 0 0 0 8 2.5zm2.95 15.06A1.06 1.06 0 0 1 12 16.5a1.06 1.06 0 0 1 0 2.11 1.07 1.07 0 0 1-1.06-1.06zm.12-3.5V5.41a.94.94 0 0 1 1.88 0v8.65a.94.94 0 1 1-1.88 0z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/revoked.svg
// module id = wcKm
// module chunks = 6